import { merge, ReplaySubject } from 'rxjs';
import { dematerialize, filter, map, materialize, share, tap } from 'rxjs/operators';
import { withLatestFromConflated } from './util/withLatestFromConflated.js';
import { UpdateParser } from './snapshotParser.js';
import { convertDescriptorsToMaskMap } from './util/convertDescriptorsToMaskMap.js';
/**
 * A class that loads historic data from a table.
 */
export class HistoricDataLoader {
    client;
    key;
    /** Every point as delivered by the server */
    point$;
    descriptors$;
    _descriptors;
    get descriptors() {
        return this._descriptors;
    }
    subscription;
    parser = new UpdateParser();
    constructor(client, key) {
        this.client = client;
        this.key = key;
        if (key.ex !== 'H') {
            throw new Error('Not a historic table');
        }
        const descriptors$ = client.historicDescriptor$.pipe(filter((x) => x.subscription === this.subscription), map((x) => x.descriptors), tap((x) => (this._descriptors = x)), share({
            connector: () => new ReplaySubject(1),
            resetOnComplete: false,
            resetOnRefCountZero: false,
        }));
        this.descriptors$ = descriptors$;
        const maskedDescriptors$ = descriptors$.pipe(map((descs) => ({
            fields: descs,
            maskMap: convertDescriptorsToMaskMap(descs),
        })));
        const snapshotsAndDescs$ = client.historicUpdate$.pipe(filter((x) => x.subscription === this.subscription), withLatestFromConflated(maskedDescriptors$), filter(([, descs]) => !!descs));
        const data = {};
        const parsedSnapshotUpdates$ = snapshotsAndDescs$.pipe(map(([update, { fields }]) => {
            // workaround for Node/Browser Buffer
            try {
                return this.parser.parse(update.payload, fields, data);
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.log(e.message);
            }
            return {};
        }), materialize());
        const complete$ = client.endOfData$.pipe(filter((x) => x.subscription === this.subscription), map(() => ({ kind: 'C' })));
        this.point$ = merge(parsedSnapshotUpdates$, complete$).pipe(dematerialize(), share({ resetOnComplete: false, resetOnRefCountZero: true }));
    }
    /** Asks the server to send data. No data is sent until this is called. */
    readMore(num = 10) {
        this.subscription = this.client.requestHistoricData(this.key, num);
    }
}
//# sourceMappingURL=historicDataLoader.js.map